import { defineLanguage } from '../../../src/domain/language/factory';

export default defineLanguage({
  languageName: 'Bengali',
  languageCode: 'bn',
  languageHeaderCode: 'bn',
});
